import {Order} from "../bo/order";

export type Card = {
    id?: string,
    number?: number,
    line?: number,
    text: string,
    designers_card: boolean
};

export function designersCardToEnd(a: Card, b: Card) {
    if (a.designers_card == b.designers_card) {
        return 0;
    }
    return a.designers_card ? 1 : -1;
}

const SMALL_CARD_LINESIZE = 33;
const DESIGNER_CARD_LINESIZE = 45;


export function orderToCards(order: Order) : Card[] {

    const cards: Card[] = [];

    const lineItems = order.lineItems || [];

    let designers_cards = 0;

    for (let idx = 0; idx < lineItems.length; idx ++) {
        const lineitem = lineItems[idx];

        let designers_card = false;
        for (const opt of lineitem.options || []) {
            if (opt.option === "Designer's card" && opt.selection && (opt.selection === "Designer's card" || opt.selection.startsWith("Yes"))) {
                designers_card = true;
                designers_cards ++;
            }
        }

        for (const field of lineitem.customTextFields || []) {
            if (field.title === "Message attached with flowers" && field.value && field.value.trim()) {

                const text = field.value.trim();
                const width = designers_card ? DESIGNER_CARD_LINESIZE : SMALL_CARD_LINESIZE;

                const formatted = flowMessage(text, width);

                const card = {
                    text: formatted,
                    designers_card: designers_card,
                    id: order.id as string,
                    number: order.number,
                    line: idx,
                }
                cards.push(card);
            }
        }
    }

    if (cards.length == 0) {
        const card = {
            text: `--- No card message for order ${order.number} ---`,
            designers_card: designers_cards > 0,
            id: order.id as string,
            number: order.number,
            line: 0,
        }
        cards.push(card);
    }

    return cards;
}

export function flowMessage(text: string, width: number) {

    const formatted = text.trim().replace(/ & /g, " and ");

    /*
    const lines: string[] = [""];
    const words = text.split(/\s+/);

    for (let word of words) {

        if (word == "&") {
            word = "and";
        }

        let line = lines[lines.length - 1];
        if (line.length + word.length > width) {
            line = "";
            lines.push(line);
        }
        line = line + word + " ";
        lines[lines.length - 1] = line;
    }

    const formatted = lines.join("\n").trim();
     */

    return formatted;
}
